<template>
  <div>
    <div class="d-flex justify-content-between">
      <h1 class="page-header">
        {{ $t('historyTracking.pageTitle') }}
      </h1>
      <ts-breadcrumb
        :items="[
          { text: $t('toHomePage'), href: '/' },
          {
            text: $t('historyTracking.pageTitle'),
            active: true
          }
        ]"
      />
    </div>
    <ts-card>
      <ts-card-wrapper>
        <div class="d-flex ts-justify-between">
          <div>
            <a-range-picker
              format="DD-MM-YYYY"
              :defaultValue="rangeDate"
              :defaultPickerValue="rangeDate"
              @change="dateRangeChange"
            >
              <template slot="renderExtraFooter"></template>
            </a-range-picker>
          </div>
          <div>
            <div class="d-flex ts-justify-end ts-space-x-3">
              <a-select
                v-model="obj_name"
                :options="obj_name_list"
                style="width: 300px"
              ></a-select>
              <ts-input
                v-model="search"
                :placeholder="$t('historyTracking.search')"
                style="width: 100%"
              />
            </div>
          </div>
        </div>
      </ts-card-wrapper>
      <ts-table :columns="columns" :records="resources" :loading="loading">
        <template v-slot="{ record }">
          <td>{{ record.action_date }}</td>
          <td>{{ record.action_time }}</td>
          <td>{{ record.object_name }}</td>
          <td>{{ record.action_name }}</td>
          <td>{{ record.key_value }}</td>
          <td>{{ record.column_name }}</td>
          <td>{{ record.old_value }}</td>
          <td>{{ record.new_value }}</td>
          <td>{{ record.username }}</td>
        </template>
      </ts-table>
      <div class="d-flex justify-content-end p-15">
        <ts-pagination v-model="pagination" @navigate="fetchData">
        </ts-pagination>
      </div>
    </ts-card>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { debounce } from 'lodash'
import moment from 'moment'

export default {
  name: 'historyTracking',
  data() {
    return {
      loading: false,
      rangeDate: [moment(), moment()],
      obj_name_list: []
    }
  },
  computed: {
    ...mapState('historyTracking', ['resources', 'pagination']),
    search: {
      get() {
        return this.$store.state.historyTracking.search
      },
      set(newValue) {
        this.$store.commit('historyTracking/SET_SEARCH', newValue)
        this.$store.commit('historyTracking/RESET_CURRENT_PAGE')
      }
    },
    obj_name: {
      get() {
        return this.$store.state.historyTracking.object_name
      },
      set(newValue) {
        this.$store.commit('historyTracking/SET_OBJECT_NAME', newValue)
      }
    },
    columns() {
      return [
        { name: this.$t('historyTracking.date') },
        { name: this.$t('historyTracking.time') },
        { name: this.$t('historyTracking.objectName') },
        { name: this.$t('historyTracking.actionName') },
        { name: this.$t('historyTracking.keyValue') },
        { name: this.$t('historyTracking.columnName') },
        { name: this.$t('historyTracking.oldValue') },
        { name: this.$t('historyTracking.newValue') },
        { name: this.$t('historyTracking.userName') }
      ]
    }
  },
  methods: {
    fetchData(attributes) {
      this.loading = true
      this.$store
        .dispatch('historyTracking/fetch', attributes)
        .then(response => {
          this.loading = false
        })
        .catch(error => {
          this.loading = false
          this.$toasted.error(error.message)
        })
    },
    dateRangeChange(dateRange) {
      this.$store.commit(
        'historyTracking/SET_DATE_FROM',
        dateRange[0].format('DD-MM-YYYY')
      )
      this.$store.commit(
        'historyTracking/SET_DATE_TO',
        dateRange[1].format('DD-MM-YYYY')
      )
      this.fetchData()
    },
    fetchObj() {
      this.$store
        .dispatch('historyTracking/getObj')
        .then(response => {
          this.obj_name_list = response.data.map(el => ({
            value: el.object_name,
            label: el.action_name
          }))
          this.obj_name_list.unshift({
            value: 'All',
            label: 'All'
          })
        })
        .catch(error => {
          this.$toasted.error(error.message)
        })
    }
  },
  watch: {
    search: debounce(function(search) {
      this.fetchData({ search })
    }, 500),
    obj_name: debounce(function(search) {
      this.fetchData()
    }, 500)
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      vm.fetchData()
      vm.fetchObj()
    })
  }
}
</script>
